var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSlickCarousel',_vm._b({staticClass:"o-slider",class:{ 'margin-bottom': _vm.settings.dots }},'VueSlickCarousel',_vm.settings,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }